function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, Alert, Tag, Select } from 'antd';
import Common from "../includes/Common";
import { Container, Col, Row } from "react-bootstrap";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";

var SetImResult = function SetImResult(_ref) {
  var im_object = _ref.im_object,
      q_item = _ref.q_item,
      m_item = _ref.m_item,
      im_type = _ref.im_type,
      handler = _ref.handler,
      _ref$result = _ref.result,
      result = _ref$result === void 0 ? null : _ref$result;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormProcessing = _useState2[0],
      setIsFormProcessing = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      successMessage = _useState6[0],
      setSuccessMessage = _useState6[1];

  var _useState7 = useState(""),
      _useState8 = _slicedToArray(_useState7, 2),
      resultString = _useState8[0],
      setResultString = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      translatorOptions = _useState10[0],
      setTranslatorOptions = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      templates = _useState12[0],
      setTemplates = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      templateOptions = _useState14[0],
      setTemplateOptions = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      selectedRt = _useState16[0],
      setSelectedRt = _useState16[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var handleRsChange = function handleRsChange(e) {
    setResultString(e);
  };

  var handleTemplateChange = function handleTemplateChange(v) {
    if (templates.filter(function (t) {
      return t.id == v;
    }).length <= 0) {
      return;
    }

    setSelectedRt(templates.filter(function (t) {
      return t.id == v;
    })[0]);
    setResultString(templates.filter(function (t) {
      return t.id == v;
    })[0].content);
    templates.filter(function (t) {
      return t.id == v;
    })[0].content;
  };

  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setSuccessMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("user_id", Common.currentUser.id);
    formData.append("cr", resultString);
    if (q_item.queue_item_elements && q_item.queue_item_elements.im_result != null) formData.append("im_result_id", q_item.queue_item_elements.im_result.id);
    formData.append("business_account_medical_item_id", m_item.id);
    formData.append("clinic_indication", values.clinic_indication);
    formData.append("translator_id", values.translator_id);
    formData.append("customer_id", q_item.customer_id);
    formData.append("type", im_type);
    formData.append("queue_item_id", q_item.id.toString());
    axios.post(Common.baseApiUrl + "setimtranslation", formData).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage("Résultats saisis avec succès");
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue " + error.toString());
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };

  useEffect(function () {
    axios.get(Common.baseApiUrl + "getplatformusers/" + Common.currentUser.id).then(function (response) {
      setTranslatorOptions([]);

      if (response.data.status == 200) {
        response.data.users.forEach(function (u) {
          if (u.role == 21) setTranslatorOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: u.id,
              label: u.firstname + " " + u.lastname
            }]);
          });
        });
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue " + error.toString());
    })["finally"](function () {});
  }, []);
  useEffect(function () {
    if (im_object != null) {
      setResultString(im_object.cr);
      form.setFieldsValue(_defineProperty({
        translator_id: im_object.translator_id,
        clinic_indication: im_object.clinic_indication
      }, "translator_id", im_object.translator_id));
    }

    axios.get(Common.baseApiUrl + "getreporttemplates/" + Common.currentUser.id).then(function (response) {
      setTemplates([]);
      setTemplateOptions([]);

      if (response.data.status == 200) {
        response.data.templates.forEach(function (e) {
          setTemplates(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              id: e.id,
              label: e.label,
              description: e.description,
              content: e.content,
              action: e
            }]);
          });
          setTemplateOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: e.id,
              label: e.label
            }]);
          });
        });
      }
    })["catch"](function (error) {})["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Descriptions, {
      size: "small",
      bordered: true,
      column: 1,
      children: [/*#__PURE__*/_jsx(Descriptions.Item, {
        label: "Examen demand\xE9",
        children: m_item != null && /*#__PURE__*/_jsx(Tag, {
          color: "red",
          children: /*#__PURE__*/_jsx("b", {
            children: m_item.label
          })
        })
      }), /*#__PURE__*/_jsx(Descriptions.Item, {
        label: "Medecin prescripteur",
        children: q_item && q_item.prescriber && q_item.prescriber.name
      })]
    }), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "M\xE9decin interprete",
            name: "translator_id",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Select, {
              options: translatorOptions,
              placeholder: "Chosir le m\xE9decin interprete"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Indication clinique",
            name: "clinic_indication",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "cr_template",
            label: "Mod\xE8les de compte rendu",
            children: /*#__PURE__*/_jsx(Select, {
              showSearch: true,
              defaultActiveFirstOption: true,
              optionLabelProp: "label",
              optionFilterProp: "label",
              onChange: handleTemplateChange,
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              options: templateOptions
            })
          })
        })]
      }), /*#__PURE__*/_jsx(ReactQuill, {
        theme: "snow",
        value: resultString,
        onChange: setResultString
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          disabled: translatorOptions.length == 0,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "SAUVEGARDER"
          })
        })
      })]
    })]
  });
};

export default SetImResult;